import type { PortalNotification } from './notificationHref';

export const isPaymentUpdate = (notification: PortalNotification): boolean =>
  notification.type === 'motor_payment_updated' || /^motor_(cash_paid|cheque_|online_|card_paid|ezcash_paid)/.test(notification.type);

/** Payments belong to an exact quotation revision, unlike uploaded documents. */
export function matchesPaymentQuotation(notification: PortalNotification, quotationNo: string): boolean {
  return isPaymentUpdate(notification) && !!quotationNo && notification.quotation_no === quotationNo;
}

export function showPaymentPopup(notification: PortalNotification, source: string, pathname: string, search: string): boolean {
  return source === 'live'
    && ['/dashboard/products/motor/documentation', '/dashboard/products/motor/policy-issue'].includes(pathname.replace(/\/$/, ''))
    && matchesPaymentQuotation(notification, new URLSearchParams(search).get('quotationNo') ?? '');
}
